define('models/pages',['require','underscore','chaplin','models/base/collection','models/page','lib/utils'],function(require) {
    'use strict';

    var _ = require('underscore'),
        Chaplin = require('chaplin'),
        Collection = require('models/base/collection'),
        Page = require('models/page'),
        utils = require('lib/utils');

    var Pages = Collection.extend({

        model: Page,

        initialize: function() {
            Collection.prototype.initialize.apply(this, arguments);
            _.extend(this, Chaplin.SyncMachine);
            this.cache = {};
        },

        byMenu: function (menu) {
            var pages = this.cache[menu];

            if (pages) {
                return pages;
            }

            pages = new Pages(this.filter(function (item) { return item.get('menu') === menu; }));
            this.cache[menu] = pages;
            return pages;
        }
    });

    return Pages;
});
